import clsx from 'clsx'

export type ColorsType = {
  [key in NonNullable<ButtonStyleProps['color']>]: string
}

export interface ButtonStyleProps {
  rank?: 'primary' | 'secondary' | 'link'
  size?: 'sm' | 'md' | 'xl' | '2xl'
  color?: 'primary' | 'danger' | 'success' | 'warning'
  linkBackground?: boolean
  disabled?: boolean
}

const primaryVariant: ColorsType = {
  primary:
    'tw:text-white tw:bg-primary-500 tw:hover:bg-primary-700 tw:aria-disabled:bg-primary-200 tw:aria-disabled:hover:bg-primary-200',
  danger: 'tw:text-white tw:bg-red-600 tw:hover:bg-red-700',
  success: 'tw:text-success-700 tw:bg-success-50 tw:border tw:border-success-600 tw:hover:bg-success-100',
  warning: 'tw:text-white tw:bg-warning-700 tw:hover:bg-warning-800',
}

const secondaryVariant: ColorsType = {
  primary:
    'tw:text-primary-700 tw:bg-primary-100 tw:hover:bg-primary-200 tw:aria-disabled:text-primary-300 tw:aria-disabled:bg-primary-50 tw:aria-disabled:hover:bg-primary-50',
  danger:
    'tw:text-red-700 tw:bg-red-100 tw:hover:bg-red-200 tw:aria-disabled:text-red-200 tw:aria-disabled:bg-red-50 tw:aria-disabled:hover:bg-red-50',
  success: 'tw:text-green-700 tw:bg-green-100 tw:hover:bg-green-200',
  warning:
    'tw:text-warning-700 tw:bg-warning-100 tw:hover:bg-warning-200 tw:aria-disabled:text-warning-200 tw:aria-disabled:bg-warning-50 tw:aria-disabled:hover:bg-warning-50',
}

const linkVariant: ColorsType = {
  primary: 'tw:text-primary-700 tw:hover:bg-primary-50',
  danger: 'tw:text-red-700 tw:hover:bg-red-50',
  success: 'tw:text-green-700 tw:hover:bg-green-50',
  warning: 'tw:text-warning-700 tw:hover:bg-warning-50',
}

export function rankColorClasses(
  variant: NonNullable<ButtonStyleProps['rank']>,
  color: NonNullable<ButtonStyleProps['color']>,
  linkBackground: ButtonStyleProps['linkBackground']
): string {
  const buttonVariants = {
    primary: primaryVariant[color],
    secondary: secondaryVariant[color],
    link: clsx(
      linkVariant[color],
      'tw:underline tw:underline-offset-4',
      'tw:aria-disabled:text-gray-300 tw:aria-disabled:hover:bg-inherit',
      linkBackground || 'tw:hover:bg-transparent'
    ),
  }

  return buttonVariants[variant] + ' tw:aria-disabled:cursor-not-allowed'
}

export function sizeClasses(size: NonNullable<ButtonStyleProps['size']>) {
  return {
    sm: 'tw:h-fit tw:text-sm tw:font-medium tw:py-2 tw:px-3',
    md: 'tw:h-fit tw:text-sm tw:font-medium tw:py-3 tw:px-4',
    xl: 'tw:h-fit tw:text-base tw:font-medium tw:py-3 tw:px-5',
    '2xl': 'tw:h-fit tw:text-base tw:font-medium tw:py-4 tw:px-7',
  }[size]
}
